import React$1 from 'react';
import PropTypes$1 from 'prop-types';
import StyledModal from './Modal.style.js';

const Modal = React$1.forwardRef(({
  children,
  isOpen,
  onClose,
  className,
  flex
}, ref) => /*#__PURE__*/React$1.createElement(StyledModal, {
  ariaHideApp: false,
  isOpen: isOpen,
  onRequestClose: onClose,
  className: className,
  flex: flex,
  ref: ref
}, children));
Modal.displayName = 'Modal';
Modal.propTypes = {
  children: PropTypes$1.node.isRequired,
  isOpen: PropTypes$1.node.isRequired,
  onClose: PropTypes$1.func,
  className: PropTypes$1.string,
  flex: PropTypes$1.bool
};
Modal.defaultProps = {
  onClose: () => {},
  className: null,
  flex: false
};

export default Modal;
